import styled, { css } from 'styled-components';
import { PhotographyWrapper } from '../photography/PhotographyStyles';

export const SupportWrapper = styled(PhotographyWrapper)`
  position: relative; z-index: 2;
  .support-shell { max-width: 1040px; margin: auto; padding: 48px 40px 64px; }
  .support-shell > section { padding: 0; margin: 0; }
  .support-header { padding-bottom: 28px; border-bottom: 1px solid #e1e7f0; margin-bottom: 36px; }
  .support-header h1 { font-size: clamp(36px, 3.8vw, 50px); margin-bottom: 16px; }
  .support-header .photo-copy { margin-bottom: 0; max-width: 760px; }
  .support-date { font: 400 16px/1.6 'Nunito Sans', sans-serif; color: #68758d; margin: 0; }
  .support-role { display: flex; flex-wrap: wrap; gap: 12px; align-items: center; margin-top: 24px; }
  .support-role label { font: 600 16px/1.5 'Nunito Sans', sans-serif; color: #1b264f; }
  .support-role select { min-width: 210px; max-width: 100%; padding: 12px 40px 12px 16px; background: #f6f8fc; border: 1px solid #cbd5e5; border-radius: 8px; font: 600 16px/1.5 'Nunito Sans', sans-serif; color: #1b264f; }
  .support-role select:focus-visible { outline: 3px solid #7c9aff; outline-offset: 3px; }
  .support-notice { font: 400 18px/1.7 'Nunito Sans', sans-serif; color: #52617e; padding: 24px; border-radius: 12px; background: #f6f8fc; margin: 0; }
  .support-contact { margin-top: 48px; padding: 28px 0 0; border-top: 1px solid #e1e7f0; display: flex; gap: 24px; align-items: center; justify-content: space-between; }
  .support-contact h2 { color: #1b264f; text-transform: none; font: 600 23px/1.4 Poppins, sans-serif; letter-spacing: -.025em; margin: 0 0 8px; }
  .support-contact p { font: 400 17px/1.6 'Nunito Sans', sans-serif; color: #52617e; margin: 0; }
  .support-contact .photo-primary { flex-shrink: 0; display: inline-block; text-decoration: none; }
  .support-navigation { display: flex; flex-wrap: wrap; gap: 12px 24px; margin-top: 32px; }
  .support-navigation a { font: 600 15px/1.5 'Nunito Sans', sans-serif; color: #52617e; text-decoration: underline; text-underline-offset: 4px; }
  .support-navigation a[aria-current='page'] { color: #2c5bff; }
  @media (max-width: 767px) {
    .support-shell { padding: 28px 20px 44px; }
    .support-header { padding-bottom: 24px; margin-bottom: 28px; }
    .support-contact { display: block; margin-top: 36px; padding-top: 24px; }
    .support-contact h2 { font-size: 21px; }
    .support-contact .photo-primary { margin-top: 20px; }
    .support-notice { padding: 20px; font-size: 17px; }
    .support-navigation { gap: 12px 20px; }
  }
`;

export const supportReadingStyles = css`
  width: 100%; max-width: none; padding: 0; margin: 0;
  text-align: left; font: 400 18px/1.8 'Nunito Sans', sans-serif; color: #52617e;
  overflow-wrap: anywhere;
  p { margin: 0 0 20px; }
  h1, h2 { font: 600 26px/1.4 Poppins, sans-serif; color: #1b264f; text-transform: none; letter-spacing: -.025em; margin: 36px 0 16px; }
  h3 { font: 600 20px/1.5 Poppins, sans-serif; color: #1b264f; text-transform: none; text-decoration: none; margin: 24px 0 12px; }
  h4 { font: 600 18px/1.5 Poppins, sans-serif; color: #1b264f; text-transform: none; margin: 20px 0 12px; }
  ul, ol { padding-left: 26px; margin: 0 0 24px; }
  li { color: #52617e; margin-bottom: 12px; }
  a { color: #2c5bff; text-decoration: underline; text-underline-offset: 3px; }
  b, strong { color: #1b264f; font-weight: 700; }
  table { max-width: 100%; }
  img { max-width: 100%; height: auto; }
  @media (max-width: 767px) { font-size: 17px; line-height: 1.75; h1, h2 { font-size: 23px; margin-top: 28px; } h3 { font-size: 19px; } ul, ol { padding-left: 22px; } }
`;
